webpackJsonp([230667518368419],{

/***/ 881:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/1.9ff8c407.png";

/***/ }),

/***/ 882:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/2.a95a3040.png";

/***/ }),

/***/ 883:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/3.5675ea59.png";

/***/ }),

/***/ 884:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/4.ad0a3ca0.png";

/***/ }),

/***/ 885:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/5.441ad243.png";

/***/ }),

/***/ 1137:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTypist = __webpack_require__(28);
	
	var _reactTypist2 = _interopRequireDefault(_reactTypist);
	
	__webpack_require__(27);
	
	var _messages = __webpack_require__(34);
	
	var _messages2 = _interopRequireDefault(_messages);
	
	var _HeadlineWithFocus = __webpack_require__(6);
	
	var _HeadlineWithFocus2 = _interopRequireDefault(_HeadlineWithFocus);
	
	var _ = __webpack_require__(881);
	
	var _2 = _interopRequireDefault(_);
	
	var _3 = __webpack_require__(882);
	
	var _4 = _interopRequireDefault(_3);
	
	var _5 = __webpack_require__(883);
	
	var _6 = _interopRequireDefault(_5);
	
	var _7 = __webpack_require__(884);
	
	var _8 = _interopRequireDefault(_7);
	
	var _9 = __webpack_require__(885);
	
	var _10 = _interopRequireDefault(_9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Index = function Index(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-content-box' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Modellazione numerica'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { textAlign: 'justify', lineHeight: '2em' } },
	      _react2.default.createElement('img', { src: _2.default, style: { width: '100%', height: '100%' } }),
	      'Negli ultimi anni ho potuto maturare dell\'esperienza nella modellazione numerica di strutture utilizzando software differenti. In questa sezione mostro alcuni esempi, principalmente legati all\'assessment di strutture esistenti. ',
	      _react2.default.createElement('br', null),
	      ' ',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Analisi Lineare Statica'
	      ),
	      'Per questo metodo di analisi viene definita una serie di forze agenti sull\'edificio, che rappresentano l\'effetto del terremoto, tipicamente definito tramite uno spettro di risposta elastico normativo. Si assume che il comportamento dell\'edificio sia dominato dal suo primo modo naturale di vibrare. Generalmente questa ipotesi \xE8 valida per edifici bassi che non presentino significative discontinuit\xE0 di massa, rigidezza e resistenza, per cui gli effetti torsionali e quelli dei modi superiori sono trascurabili. Usando questo tipo di analisi elastica, la risposta laterale dell\'edificio pu\xF2 essere apprezzata solo fino allo snervamento del primo dei suoi componenti, dato che non \xE8 possibile cogliere la ridistribuzione delle azioni in campo plastico. In genere si utilizzano dei fattori di riduzione della domanda sismica per considerare il comportamento non-lineare della struttura in maniera approssimativa. ',
	      _react2.default.createElement('br', null),
	      ' ',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('img', { src: _4.default, style: { width: '100%', height: '100%' } }),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Analisi modale con spettro di risposta (Lineare Dinamica)'
	      ),
	      'L\'analisi modale con spettro di risposta, chiamata spesso lineare dinamica, \xE8 il metodo di riferimento comunemente usato per il progetto di edifici nuovi. Il metodo permette di considerare l\'effetto dei modi superiori di vibrare, seppur confinato al regime elastico. Per prima cosa si fa un\'analisi agli autovalori per determinare le propriet\xE0 dinamiche in campo elastico della struttura: forma dei modi di vibrare, frequenze naturali, masse partecipanti, etc. Grazie ad un criterio relativo alla massa partecipante (cumulata) dell\'edificio \xE8 possibile scegliere un numero di modi di vibrare significativi da tenere in conto nell\'analisi. Per ognuno di essi si conduce un\'analisi Lineare Statica, utilizzando la forma modale, la massa partecipante e uno spettro di risposta. Gli effetti dell\'azione sismica per ogni modo (tagli di piano, spostamenti, azioni interne, etc.) sono combinati utilizzando approcci basati sulla statistica per determinare la massima risposta dell\'edificio. Tipicamente si usano il metodo della radice quadrata della somma dei quadrati (SRSS, Square Root of the Sum of the Squares) o la Combinazione Quadratica Completa (CQC). ',
	      _react2.default.createElement('br', null),
	      ' ',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('img', { src: _6.default, style: { width: '100%', height: '100%' } }),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Analisi Pushover (Non-Lineare Statica)'
	      ),
	      'Un\'analisi non-lineare statica, o Pushover, \xE8 un metodo in cui la struttura \xE8 soggetta a carichi verticali costanti (gravitazionali) a carichi orizzontali variabili in modo tale da imcrementare in maniera monotona lo spostamento di un punto della struttura selezionato detto nodo di controllo (Pushover in controllo di spostamento). I carichi orizzontali, che rappresentano le forze d\'inerzia in maniera semplificata, sono modellati come forze agenti al centro di massa dell\'edificio ad ogni piano. Nei metodi Pushover tradizionali la distribuzione delle forze rimane invariata con l\'incrementare dello spostamento del nodo di controllo. ',
	      _react2.default.createElement('br', null),
	      ' ',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('img', { src: _8.default, style: { width: '100%', height: '100%' } }),
	      ' ',
	      _react2.default.createElement('br', null),
	      ' ',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Analisi Time History (Non-Lineare Dinamica)'
	      ),
	      'L\'analisi Time History non-lineare consiste nel calcolo della risposta nel tempo in campo non-lineare di una struttura i cui vincoli sono sottoposti ad una storia di accelerazione. Questo \xE8 possibile tramite l\'integrazione numerica delle equazioni differenziali del moto, calcolata tramite l\'uso di un software. Ovviamente il modello numerico usato deve essere in grado di cogliere la risposta non lineare degli elementi strutturali, compresi i cicli di carico e scarico isteretici. ',
	      _react2.default.createElement('br', null),
	      'Questo metodo non \xE8 utilizzato per prevedere la risposta effettiva della struttura ad un particolare accelerogramma, dato che sia la domanda che la capacit\xE0 sono affette da grandi incertezze. Inoltre \xE8 necessario adottare un certo numero di ipotesi nella costruzione del modello numerico che, a prescindere dalla sua complessit\xE0, non \xE8 in grado di catturare tutti i possibili meccanismi di collasso. Attraverso un compromesso tra complessit\xE0 e capacit\xE0 del modello, con questo tipo di analisi \xE8 possibile ottenere la stima pi\xF9 affidabile possibile dei trend di comportamento della struttura, a patto che il giudizio ingegneristico guidi sia la creazione del modello sia la interpretazione dei suoi risultati.',
	      _react2.default.createElement('img', { src: _10.default, style: { width: '100%', height: '100%' } }),
	      ' ',
	      _react2.default.createElement('br', null),
	      ' ',
	      _react2.default.createElement('br', null)
	    )
	  );
	};
	
	exports.default = Index;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-3-d-it-jsx-ba012fdc5f80796f78f2.js